import {AppIcon, FaChevronDownIcon, FaChevronUpIcon} from '../icon';

export interface DisclosureChevronProps {
  open: boolean;
  size?: 'xs' | 'sm';
}

const SIZE_EM: Record<'xs' | 'sm', string> = {xs: '10px', sm: '0.875em'};

export function DisclosureChevron({open, size = 'xs'}: DisclosureChevronProps) {
  const sx = {fontSize: SIZE_EM[size]};
  return <AppIcon icon={open ? FaChevronUpIcon : FaChevronDownIcon} sx={sx} aria-hidden />;
}

DisclosureChevron.displayName = 'DisclosureChevron';
